var _style, _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 402.7 448.1",
    style: {
      enableBackground: "new 0 0 402.7 448.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill: currentColor;}\n\t.st1{fill:#FAB52B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394.5,330.6l-27.4-39.4c-3.7-5.4-5.7-11.7-5.8-18.2V160c0-88.4-71.6-160-160-160s-160,71.6-160,160v113 c0,6.5-2,12.9-5.8,18.2L8.2,330.6c-11.8,13.1-10.8,33.4,2.3,45.2C16.4,381,24,384,31.9,384h91c8.8,43.3,51,71.3,94.3,62.5 c31.5-6.4,56.1-31,62.5-62.5h91c17.7,0,32-14.4,31.9-32.1C402.7,344,399.8,336.4,394.5,330.6L394.5,330.6z M201.4,416 c-20.3-0.1-38.4-12.9-45.1-32h90.2C239.7,403.1,221.7,415.9,201.4,416z M31.9,352c0.7-0.7,1.4-1.4,1.9-2.2l28-40.3 c7.5-10.7,11.5-23.4,11.5-36.5V160c0-70.7,57.3-128,128-128s128,57.3,128,128v113c0,13.1,4.1,25.8,11.5,36.5l28,40.3 c0.6,0.8,1.2,1.6,1.9,2.2H31.9z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 308.1,
    cy: 151.8,
    r: 94.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification02);
export default __webpack_public_path__ + "static/media/notification-02.475b990a29fcab79903618dd2bda8272.svg";
export { ForwardRef as ReactComponent };